"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OnsiteTechnicalSupport() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const plateCodes = ["SIEMENS-840D", "HEIDENHAIN-TNC", "FANUC-OI-MF", "SINUMERIK-ONE", "DRIVE-S120", "MOTOR-1FK7", "PLC-S7-1500", "HMI-TP1200", "CNC-RETROFIT", "AXIS-CALIB", "SPINDLE-REP", "LOGIC-GATE"];
  return <section data-section-id="2111" id="onsite-technical-support" className="relative overflow-hidden py-24 md:py-44 text-foreground light bg-background" style={{
    backgroundColor: "hsl(0 0% 100%)",
    color: "hsl(220 48% 12%)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -left-12 top-1/2 hidden -translate-y-1/2 select-none font-default leading-none md:block" style={{
      fontSize: "clamp(420px, 48vw, 720px)",
      WebkitTextStroke: "1px hsl(220 48% 12%)",
      color: "transparent",
      opacity: 0.04,
      fontWeight: 800
    }}>
        CNC
      </div>

      <div className="relative mx-auto max-w-[1440px] px-5 md:px-8 lg:px-14">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          {}
          <div ref={leftRef} className="relative lg:col-span-5 lg:pr-6" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 720ms cubic-bezier(0.16, 1, 0.3, 1), transform 720ms cubic-bezier(0.16, 1, 0.3, 1)"
        }}>
            {}
            <div className="mb-5 flex items-center gap-3 font-mono uppercase" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.1em"
          }}>
              
              <span style={{
              color: "hsl(220 10% 45%)"
            }}>Field Sevices / SIEMENS SYSTEMS</span>
            </div>

            {}
            <div className="mb-10 flex items-center gap-3">
              <span className="block h-px flex-1" style={{
              backgroundColor: "hsl(220 10% 90%)"
            }} />
              <span className="flex items-center gap-1">
                <span className="block size-1 rounded-lg" style={{
                backgroundColor: "hsl(183 100% 32%)"
              }} />
                <span className="block size-1 rounded-lg" style={{
                backgroundColor: "hsl(183 100% 32%)"
              }} />
                <span className="block size-1 rounded-lg" style={{
                backgroundColor: "hsl(183 100% 32%)"
              }} />
              </span>
            </div>

            {}
            <h1 className="font-default" style={{
            fontSize: "clamp(2.75rem, 6.4vw, 6.5rem)",
            fontWeight: 800,
            letterSpacing: "-0.04em",
            lineHeight: 1.1,
            color: "hsl(220 48% 12%)"
          }}>
              Precision in{" "}
              <em className="font-default not-italic" style={{
              display: "inline-block",
              color: "hsl(183 100% 32%)",
              opacity: leftVisible ? 1 : 0,
              transform: leftVisible ? "translateX(0)" : "translateX(0.4em)",
              transition: "opacity 600ms ease-out 200ms, transform 600ms ease-out 200ms"
            }}>
                Integration
              </em>
              , part by part.
            </h1>

            {}
            <p className="mt-8 font-default" style={{
            maxWidth: "44ch",
            fontSize: "clamp(1.125rem, 1.5vw, 1.1875rem)",
            fontWeight: 400,
            lineHeight: 1.6,
            color: "hsl(220 48% 12%)"
          }}>A comprehensive technical atlas of IMCNC Designs' integration projects — documenting Siemens retrofitting, specialized field services, and industrial automation across South Africa.</p>

            {}
            <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:gap-10">
              <Link to="/FieldServicesPage" className="group relative inline-flex w-fit items-center gap-2 font-default" style={{
              color: "hsl(183 100% 32%)",
              fontWeight: 500
            }}>
                
                
              </Link>
              <Link to="/PartsCataloguePage" className="group relative inline-flex w-fit items-center gap-2 font-default" style={{
              color: "hsl(183 100% 32%)",
              fontWeight: 500
            }}><span className="relative">
                  Spare Parts
                  <span aria-hidden="true" className="absolute -bottom-1 left-0 block h-px w-full origin-left scale-x-0 transition-transform duration-300 ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:scale-x-100" style={{
                  backgroundColor: "hsl(183 100% 32%)"
                }} />
                </span>
                <span className="font-mono" style={{
                fontSize: "0.875rem"
              }}>
                  →
                </span></Link>
            </div>

            {}
            <div className="mt-12 inline-flex items-center gap-3 font-mono uppercase" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.1em",
            color: "hsl(220 10% 45%)"
          }}>
              
              <span style={{
              color: "hsl(183 100% 32%)"
            }}>·</span>
              
              <span style={{
              color: "hsl(183 100% 32%)"
            }}>·</span>
              
            </div>
          </div>

          {}
          <div ref={rightRef} className="relative lg:col-span-7" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 720ms cubic-bezier(0.16, 1, 0.3, 1) 120ms, transform 720ms cubic-bezier(0.16, 1, 0.3, 1) 120ms"
        }}>
            <div className="group relative">
              {}
              <div className="relative overflow-hidden" style={{
              borderRadius: "0px",
              aspectRatio: "16 / 11",
              border: "1px solid hsl(220 10% 90%)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696316/img/siemens_cnc_control_panel.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696316/img/siemens_cnc_control_panel.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696316/img/siemens_cnc_control_panel.png-wvc-sizes" alt="Siemens CNC control panel integration by IMCNC Designs" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.02]" />

                {}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 overflow-hidden border-t" style={{
                backgroundColor: "hsla(0, 0%, 100%, 0.95)",
                borderColor: "hsl(183 100% 32%)"
              }}>
                  <div className="flex whitespace-nowrap py-3 font-mono" style={{
                  fontSize: "0.75rem",
                  letterSpacing: "0.1em",
                  color: "hsl(220 48% 12%)",
                  animation: "grid-ticker 40s linear infinite"
                }}>
                    {[...plateCodes, ...plateCodes].map((code, i) => <span data-index={i} key={i} className="mx-6 inline-flex items-center gap-6">
                        <span>{code}</span>
                        <span style={{
                      color: "hsl(183 100% 32%)"
                    }}>·</span>
                      </span>)}
                  </div>
                </div>
              </div>

              {}
              <span aria-hidden="true" className="pointer-events-none absolute -left-2 -top-2 block size-3.5" style={{
              borderTop: "1px solid hsl(183 100% 32%)",
              borderLeft: "1px solid hsl(183 100% 32%)"
            }} />
              <span aria-hidden="true" className="pointer-events-none absolute -right-2 -top-2 block size-3.5" style={{
              borderTop: "1px solid hsl(183 100% 32%)",
              borderRight: "1px solid hsl(183 100% 32%)"
            }} />
              <span aria-hidden="true" className="pointer-events-none absolute -bottom-2 -left-2 block size-3.5" style={{
              borderBottom: "1px solid hsl(183 100% 32%)",
              borderLeft: "1px solid hsl(183 100% 32%)"
            }} />
              <span aria-hidden="true" className="pointer-events-none absolute -bottom-2 -right-2 block size-3.5" style={{
              borderBottom: "1px solid hsl(183 100% 32%)",
              borderRight: "1px solid hsl(183 100% 32%)"
            }} />
            </div>

            {}
            <div className="mt-6 flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center">
              <div className="font-mono uppercase" style={{
              fontSize: "0.75rem",
              letterSpacing: "0.1em",
              color: "hsl(220 10% 45%)"
            }}>
                
                <span className="mx-2">—</span>
                <span>SIEMENS 840D / RETROFIT / ONSITE</span>
              </div>

              <Link to="/PartsCataloguePage"><Button className="h-[52px] rounded-lg px-7 font-default" style={{
                backgroundColor: "hsl(90 62% 40%)",
                color: "hsl(0 0% 100%)",
                fontWeight: 600
              }}>
                  CONTACT AN EXPERT
                </Button></Link>
            </div>

            <div className="mt-12 border p-8 font-default" style={{
            borderColor: "hsl(220 10% 90%)",
            backgroundColor: "hsl(0 0% 100%)"
          }}>
              <div className="mb-6 flex items-center gap-2">
                <span className="h-4 w-1" style={{
                backgroundColor: "hsl(183 100% 32%)"
              }} />
                <h3 className="font-mono text-sm font-semibold tracking-widest uppercase" style={{
                color: "hsl(220 48% 12%)"
              }}>
                  [SERVICE_SPECIFICATION]
                </h3>
              </div>
              
              
              
              

              <p className="mb-8 text-base leading-relaxed" style={{
              color: "hsl(220 10% 45%)"
            }}>Our field service team provides comprehensive on-site support across South Africa, ensuring your CNC machinery operates at peak efficiency with minimal disruption to your production schedule.</p>

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {["Rapid Onsite Fault Diagnosis", "Drive Optimilization", "PLC Logic & HMI Customization", "Axis Calibration & Geometric Agnment"].map((benefit, i) => <div data-index={i} key={i} className="flex items-start gap-3">
                    <span className="mt-1.5 block size-1.5 shrink-0" style={{
                  backgroundColor: "hsl(183 100% 32%)"
                }} />
                    <span className="text-sm font-medium uppercase tracking-wide" style={{
                  color: "hsl(220 48% 12%)"
                }}>
                      {benefit}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes grid-ticker {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}